// extracted by mini-css-extract-plugin
module.exports = {"addTopGap":"_e8692e79","titleWrapper":"_2214a196","title":"_a8c321e5","subtitle":"_2235c5e1"};